import {useContext, useEffect} from 'react';
import {Link as RouterLink} from 'react-router-dom';
import {useReducedMotion, motion} from 'framer-motion';
import ErrorMessage from '../ErrorMessage/ErrorMessage';
import languageSensitiveNum from '../../../../utilities/languageSensitiveNum';
import {invoicesVariants} from '../../../../utilities/framerVariants';
import {AppContext} from "../../../../context/AppContext";
import styles from './List.module.scss';
import Status from "../../../elements/Status/Status";
import Icon from "../../../elements/Icon/Icon";
import Spinner from "../../../elements/Spinner/Spinner";
import {useSelector} from "react-redux";
import dayjs from "dayjs";
import clsx from "clsx";

const List = () => {
    const loading = useSelector((state) => state.invoices.loading);
    const {invoices} = useSelector((state) => state.invoices);
    const {users} = useSelector((state) => state.user);
    const {windowWidth} = useContext(AppContext);
    const isDesktop = windowWidth >= 768;
    const isEmpty = invoices.length === 0;
    const shouldReduceMotion = useReducedMotion();

    const variant = (element, index) => {
        return shouldReduceMotion
            ? invoicesVariants.reduced
            : invoicesVariants[element](index);
    };

    useEffect(() => {
        document.title = `Invoices (${invoices.length})`;
    }, [invoices]);

    if (loading) {
        return <Spinner/>
    }

    return (
        <>
            {isEmpty && <ErrorMessage/>}
            {!isEmpty && (
                <ul className={styles.list}>
                    {invoices.map(
                        ({number, id, userId, dueDate, status, sender, total, createdAt}, index) => {
                            const user = users.find((user) => user.id === userId?.id);
                            const isDisabled = user?.isDisabled;

                            return <motion.li
                                className={styles.item}
                                key={id}
                                layout
                                variants={variant('list', index)}
                                initial="hidden"
                                animate="visible"
                                exit="exit"
                            >
                                <RouterLink className={styles.link} to={`/invoice/${id}`}>
                                    <p className={styles.id}>
                                        <span className={styles.hashtag}># </span>
                                        {number}
                                    </p>
                                    <p className={styles.name}>
                                        {sender.name} {sender.surname}
                                    {user && (
                                        <span className={clsx(styles.userStatus, {
                                            [styles.disabled]: isDisabled,
                                            [styles.active]: !isDisabled,
                                        })}>
                                            {isDisabled ? "(Disabled)" : "(Active)"}
                                        </span>
                                    )}
                                    </p>
                                    <p className={styles.email}>
                                        {sender.email}
                                    </p>
                                    <p className={styles.paymentDue}>
                                        Due {dueDate}
                                    </p>
                                    <p className={styles.send}>
                                        Send {dayjs(createdAt).format('DD MMM YYYY')}
                                    </p>
                                    <p className={styles.totalPrice}>
                                        £&nbsp;{languageSensitiveNum(total)}
                                    </p>
                                    <Status currStatus={status}/>
                                    {isDesktop && (
                                        <Icon
                                            name={'arrow-right'}
                                            size={10}
                                            color={'var(--color-teal)'}
                                        />
                                    )}
                                </RouterLink>
                            </motion.li>
                    }
                    )}
                </ul>
            )}
        </>
    );
};

export default List;
